import React, { useEffect, useState } from "react";
import MyVehiclesCard from "../components/profile/MyVehiclesCard";
import MyBookingsCard from "../components/profile/MyBookingsCard";
import ReservationCard from "../components/profile/ReservationCard";
import ProfieDetails from "../components/profile/ProfileDetails";
import { api } from "../api/api";
import Swal from "sweetalert2";

function ProfilePage({loading, setLoading}) {
  const [activeTab, setActiveTab] = useState("profile");
  const [bookings, setBookings] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchBookings = () => {
      // Fetch bookings
      setLoading(true);
      api.get("/bookings/getBookings").then((response) => {
        console.log(response.data.bookings);
        setBookings(response.data.bookings);
      setLoading(false);
      });
    };
    fetchBookings();
  }, []);

  useEffect(() => {
    setLoading(true);
    api
      .get("/vehicles/getExactlyAllVehicles")
      .then((response) => {
        setVehicles(response.data.vehicles);
      })
      .catch((error) => console.log(error))
      .finally(() => setLoading(false));
  }, []);

  // Check if user is logged in on component mount
  useEffect(() => {
    setLoading(true);
    api
      .get("/users/checklogin", { withCredentials: true })
      .then((response) => {
        setUser(response.data.user.user);
        setIsLoggedIn(true);
      })
      .catch(() => setUser(null));
      setLoading(false);
  }, []);

  const tabs = [
    {
      id: "profile",
      label: "My Details",
      icon: "user",
      content:
        "",
    },
    {
      id: "dashboard",
      label: "My Bookings",
      icon: "calendar",
      content: (() => {
        const userBookings = bookings?.filter((booking) => booking?.userId === user?._id);
        if (userBookings.length === 0 && activeTab === "dashboard") {
          Swal.fire({
            icon: "info",
            title: "No Bookings",
            text: "You have no Bookings at this time! Please book a vehicle to see your bookings.",
          }).then((result) => {
            if (
              result.isConfirmed ||
              result.dismiss ===
                Swal.DismissReason.backdrop ||
              result.dismiss === Swal.DismissReason.esc
            ) {
              window.location.reload();
            }
          });
          return; 
        }
        return userBookings?.map((booking) => (
          <MyBookingsCard key={booking?._id} booking={booking} />
        ));
      })(),
    },
    {
      id: "settings",
      label: "My Vehicles",
      icon: "car",
     
      content: (() => {
        const userVehicles = vehicles?.filter((vehicle) => vehicle?.userId === user?._id);
        if (userVehicles?.length === 0 && activeTab === "settings") {
          Swal.fire({
            icon: "info",
            title: "No Vehicles",
            text: "You have no Vehicles at this time! Please Add a vehicle to see your vehicles.",
          }).then((result) => {
            if (
              result.isConfirmed ||
              result.dismiss ===
                Swal.DismissReason.backdrop ||
              result.dismiss === Swal.DismissReason.esc
            ) {
              window.location.reload();
            }
          });
          return; 
        }
        return userVehicles.map((vehicle) => (
          <MyVehiclesCard key={vehicle._id} vehicle={vehicle} />
        ));
      })(),
    },
    {
      id: "contacts",
      label: "Reservations",
      icon: "bookmark",
      content: "",
    },
  ];

  return (
    <div className="w-full mx-auto mt-5">
      {/* Tabs */}
      <div className="flex flex-wrap border-b border-gray-200 mb-4 mx-10 justify-center">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`flex items-center px-4 py-2 mr-2 mb-2 rounded-t-lg text-sm font-medium transition-colors duration-200 ${
              activeTab === tab.id
                ? "bg-purple-100 text-purple-800 border-b-2 border-purple-600"
                : "text-gray-600 hover:text-purple-600 hover:bg-purple-50"
            }`}
            style={{
              borderColor: activeTab === tab.id ? "#6f48e5" : "transparent",
              color: activeTab === tab.id ? "#6f48e5" : "",
            }}
            onClick={() => setActiveTab(tab.id)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {tab.icon === "user" && (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                />
              )}
              {tab.icon === "calendar" && (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
              )}
              {tab.icon === "car" && (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10M22 15H2"
                />
              )}
              {tab.icon === "bookmark" && (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"
                />
              )}
            </svg>
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="bg-white mx-10">
        {tabs.map(
          (tab) =>
            activeTab === tab.id && (
              <div
                key={tab.id}
                className="prose max-w-none"
                style={{
                  color: "#1a1a1a",
                }}
              >
                <h2
                  className="text-xl font-medium mb-4"
                  style={{ color: "#6f48e5" }}
                ></h2>
                <div>
                {activeTab === "profile" && (
                  <div className="flex justify-center w-full ">
                    <ProfieDetails/>
                  </div>
                )}
                  {activeTab === "contacts" && (
                    <div className="flex flex-col items-center w-full gap-2 mt-14">
                      {vehicles
                        .filter((vehicle) => vehicle?.userId === user?._id)
                        .flatMap((vehicle) => {
                          const relatedBookings = bookings.filter(
                            (booking) => booking?.vehicleId === vehicle?._id
                          );
                          

                          // If no bookings found, return the vehicle with null booking
                          if (relatedBookings?.length === 0) {
                          
                            Swal.fire({
                              icon: "info",
                              title: "No Reservations",
                              text: "You have no reservations at this time!",
                            }).then((result) => {
                              if (
                                result.isConfirmed ||
                                result.dismiss ===
                                  Swal.DismissReason.backdrop ||
                                result.dismiss === Swal.DismissReason.esc
                              ) {
                                window.location.reload();
                              }
                            });
                            return; // Just return without reloading immediately
                          }
                          // Otherwise, return a card for each booking of this vehicle
                          return relatedBookings?.map((booking) => (
                            <ReservationCard
                              key={`${vehicle?._id}-${booking?._id}`}
                              vehicle={vehicle}
                              booking={booking}
                            />
                          ));
                        })}
                    </div>
                  )}
                 
                  <div className="flex justify-center">
                    <div className="max-w-6xl grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-10 md:gap-2 lg:gap-5 sm:mx-10 mt-10">
                      {typeof tab.content === "string" ? (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: tab.content.replace(
                              /\*\*(.*?)\*\*/g,
                              '<strong style="color: #6f48e5">$1</strong>'
                            ),
                          }}
                        />
                      ) : (
                        tab.content
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )
        )}
      </div>
    </div>
  );
}

export default ProfilePage;
